<template>
	<svg
		:width="size"
		:height="size"
		:class="{
			'small': small,
			'medium': medium,
			'large': large,
			'extra-large': extraLarge,
		}"
		:fill="color"
		:viewBox="getViewBox"
	>
		<path :d="getPathD"/>
	</svg>
</template>

<script>
import sprite from './sprite-icons';

export default {
  name: 'icon',
  props: {
    description: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '24',
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    extraLarge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getPathD() {
      return sprite.icon[this.description].path.d;
    },
    getViewBox() {
      return sprite.icon[this.description].svg.viewBox;
    },
  },
};
</script>

<style lang="sass" scoped>
	svg
		&.small
			width: 32px
			height: 32px
		&.medium
			width: 40px
			height: 40px
		&.large
			width: 48px
			height: 48px
		&.extra-large
			width: 60px
			height: 60px
</style>
